import { DroughtMode } from '../../types';

export class DroughtPanel {
  public render(state: any): string {
    const currentMode: DroughtMode = state.droughtMode || 'usdm';

    const usdmLegend = `
      <div style="display: flex; flex-direction: column; gap: 6px;">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(153, 27, 27, 0.15); border: 1px solid rgba(153, 27, 27, 0.4); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #991b1b; box-shadow: 0 0 6px rgba(153, 27, 27, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fca5a5;">D4 — Exceptional Drought</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Water emergencies</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(239, 68, 68, 0.12); border: 1px solid rgba(239, 68, 68, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #ef4444; box-shadow: 0 0 6px rgba(239, 68, 68, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #f87171;">D3 — Extreme Drought</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Major crop/pasture loss</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(249, 115, 22, 0.12); border: 1px solid rgba(249, 115, 22, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #f97316; box-shadow: 0 0 6px rgba(249, 115, 22, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fb923c;">D2 — Severe Drought</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Water restrictions</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(251, 191, 36, 0.12); border: 1px solid rgba(251, 191, 36, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #fbbf24; box-shadow: 0 0 6px rgba(251, 191, 36, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fde68a;">D1 — Moderate Drought</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Streams/wells low</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(253, 224, 71, 0.10); border: 1px solid rgba(253, 224, 71, 0.3); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #fde047; box-shadow: 0 0 6px rgba(253, 224, 71, 0.5);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fef08a;">D0 — Abnormally Dry</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Lingering deficit</span>
        </div>
      </div>
    `;

    const outlookLegend = `
      <div style="display: flex; flex-direction: column; gap: 6px;">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(153, 27, 27, 0.15); border: 1px solid rgba(153, 27, 27, 0.4); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #991b1b; box-shadow: 0 0 6px rgba(153, 27, 27, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fca5a5;">Drought Persists</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Conditions linger</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(249, 115, 22, 0.12); border: 1px solid rgba(249, 115, 22, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #f97316; box-shadow: 0 0 6px rgba(249, 115, 22, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fb923c;">Development Likely</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">New deficits</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(251, 191, 36, 0.12); border: 1px solid rgba(251, 191, 36, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #fbbf24; box-shadow: 0 0 6px rgba(251, 191, 36, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #fde68a;">Remains but Improves</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Partial recovery</span>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: rgba(34, 197, 94, 0.12); border: 1px solid rgba(34, 197, 94, 0.35); border-radius: 6px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 12px; height: 12px; border-radius: 3px; background: #22c55e; box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);"></span>
            <span style="font-size: 0.80rem; font-weight: 700; color: #86efac;">Drought Removal Likely</span>
          </div>
          <span style="font-size: 0.70rem; color: #94a3b8;">Drought ends</span>
        </div>
      </div>
    `;

    return `
      <div style="display: flex; flex-direction: column; gap: 10px; font-family: 'Plus Jakarta Sans', system-ui, sans-serif;">
        <!-- Mode Switcher Pill -->
        <div style="display: flex; background: rgba(15, 23, 42, 0.6); padding: 3px; border-radius: 8px; border: 1px solid rgba(255, 255, 255, 0.08);">
          <button
            type="button"
            onclick="window.setDroughtMode('usdm')"
            style="flex: 1; padding: 5px 4px; font-size: 0.72rem; font-weight: 600; line-height: 1.25; text-align: center; border: none; border-radius: 6px; cursor: pointer; transition: all 0.15s ease; ${
              currentMode === 'usdm'
                ? 'background: #0284c7; color: #ffffff; box-shadow: 0 2px 8px rgba(2, 132, 199, 0.4);'
                : 'background: transparent; color: #94a3b8;'
            }"
          >
            Weekly Monitor<br><span style="font-size: 0.62rem; opacity: 0.90; font-weight: 500;">(Current Conditions)</span>
          </button>
          <button
            type="button"
            onclick="window.setDroughtMode('outlook')"
            style="flex: 1; padding: 5px 4px; font-size: 0.72rem; font-weight: 600; line-height: 1.25; text-align: center; border: none; border-radius: 6px; cursor: pointer; transition: all 0.15s ease; ${
              currentMode === 'outlook'
                ? 'background: #0284c7; color: #ffffff; box-shadow: 0 2px 8px rgba(2, 132, 199, 0.4);'
                : 'background: transparent; color: #94a3b8;'
            }"
          >
            Monthly Tendency<br><span style="font-size: 0.62rem; opacity: 0.90; font-weight: 500;">(Forecast)</span>
          </button>
        </div>

        <!-- Legend Swatches -->
        ${currentMode === 'outlook' ? outlookLegend : usdmLegend}

        <!-- Footer Caption -->
        <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.68rem; color: #64748b; margin-top: 2px;">
          <span>${currentMode === 'outlook' ? 'Source: NOAA CPC' : 'Source: NDMC / USDA / NOAA'}</span>
          <span>Click map for details</span>
        </div>
      </div>
    `;
  }
}

export default DroughtPanel;
